import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  message:
    'Some figures may display as a negative value due to refunds and transfer returns.',
})
